exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".history-items[data-v-aca5a606]{height:450px;overflow-y:auto}", ""]);

// exports
